import { Pipe, PipeTransform } from '@angular/core';

type named = { name: string };

@Pipe({
  name: 'searchByName'
})
export class SearchByNamePipe implements PipeTransform {

  transform<T extends named> (array: T[], keyword: string):  T[] {
    return array.filter((element) => {
      return element.name.toLowerCase().includes(keyword.toLowerCase())
    });
  }

}


